import React, { useCallback, useEffect, useState } from "react";

import { JOM_SEARCH_TAB_INDEX } from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehiclePickerForm/consts";

import { Errors } from "services/forms/validation/types";
import { NewPriceFormValues } from "services/api/catalog/cvh/types";
import { FleetVehicleEditFormValues } from "services/api/fleet/vehicles/types";
import { CatalogVehicleResult } from "services/api/catalog/vehicles/types";
import { getVehicleTypeAPI } from "services/api/catalog/vehicles/types/api";
import VehiclePickerForm from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehiclePickerForm/VehiclePickerForm";
import { VehicleInfo } from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleSummaryCard/types";

interface NewPriceBasicDataFormProps {
  show: boolean;
  formValues: NewPriceFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<NewPriceFormValues>>;
  errors: Errors;
  pickerFormValues: FleetVehicleEditFormValues;
  setPickerFormValues: React.Dispatch<React.SetStateAction<FleetVehicleEditFormValues>>;
  pickerErrors: Errors;
  setPickerErrors: React.Dispatch<React.SetStateAction<Errors>>;
  vehicleInfo: VehicleInfo;
  setVehicleInfo: React.Dispatch<React.SetStateAction<VehicleInfo>>;
}

const NewPriceBasicDataForm: React.FC<NewPriceBasicDataFormProps> = ({
  show,
  formValues,
  setFormValues,
  errors,
  pickerFormValues,
  setPickerFormValues,
  pickerErrors,
  setPickerErrors,
  vehicleInfo,
  setVehicleInfo,
}) => {
  const [pickerTabIndex, setPickerTabIndex] = useState<number>(JOM_SEARCH_TAB_INDEX);

  useEffect(() => {
    if (!pickerFormValues.vehicleTypeId || !pickerFormValues.vehicleManufacturerId || !pickerFormValues.vehicleModelId) return;
    fetchJom();
  }, [pickerFormValues.vehicleTypeId, setFormValues]);

  const fetchJom = async () => {
    try {
      const vehicleType = await getVehicleTypeAPI(
        pickerFormValues.vehicleManufacturerId!,
        pickerFormValues.vehicleModelId!,
        pickerFormValues.vehicleTypeId!
      );
      if (vehicleType?.jom) {
        setFormValues((prev) => ({ ...prev, jom: vehicleType.jom! }));
      }
    } catch {
      // ignore
    }
  };

  const handleJomSelect = useCallback((vehicle: CatalogVehicleResult) => {
    if (vehicle.vehicleType?.jom) {
      setFormValues((prev) => ({ ...prev, jom: vehicle.vehicleType!.jom! }));
    }
  }, [setFormValues]);

  return (
    <div className="px-4 space-y-4">
      <div className="flex flex-col">
        <div className="flex-1 pt-3 mb-4 border-slate-200 border px-3 pt-4 pb-3">
          <p className="text-sm text-slate-700 mb-2 font-bold">Odaberite vozilo</p>
          <p className="text-sm text-slate-500 mb-2">Odaberite vozilo iz izbornika ili pretražite putem JOM broja kako biste nastavili s izračunom.</p>
          <VehiclePickerForm
            formValues={pickerFormValues}
            setFormValues={setPickerFormValues}
            errors={pickerErrors}
            setErrors={setPickerErrors}
            vehicleInfo={vehicleInfo}
            setVehicleInfo={setVehicleInfo}
            onJomSelect={handleJomSelect}
            onTabChange={setPickerTabIndex}
          />
          {/*
            Obje kartice pune isti JOM, ali korisnik na pretrazi po vozilu bira marku, model i
            tip — poruka o praznom JOM broju ondje ne kaže što mu je činiti.
          */}
          {errors.jom && (
            <p className="text-red-500 text-xs mt-1">
              {pickerTabIndex === JOM_SEARCH_TAB_INDEX
                ? errors.jom
                : "Odaberite marku, model i tip vozila"}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewPriceBasicDataForm;
